import { getEnvVar } from "@/utils/env";
import { BaseRepositoryV2 } from "../base-repository-v2";
import type { PutEventVisitReportPayload } from "./types";

export class PeopleRepositoryV2 extends BaseRepositoryV2 {
  private basePath = "/people-web";

  constructor() {
    const baseUrl = getEnvVar("NEXT_PUBLIC_API_CORE_URL");
    super(baseUrl);
  }

  /**
   * Get current person
   * Endpoint: /people/persons/me
   */
  async getMe(customHeaders?: Record<string, string>): Promise<Response> {
    return this.get(`${this.basePath}/persons/secure/me`, customHeaders, true);
  }

  /**
   * Get invitation by ID
   * Endpoint: /people-web/invitation/{id}
   */
  async getInvitation(id: string, customHeaders?: Record<string, string>): Promise<Response> {
    return this.get(`${this.basePath}/invitation/${id}`, customHeaders, true);
  }

  /**
   * Activate invitation by ID
   * Endpoint: /people-web/invitation/{id}/activate
   */
  async activateInvitation(id: string, customHeaders?: Record<string, string>): Promise<Response> {
    return this.get(`${this.basePath}/invitation/${id}/activate`, customHeaders, true);
  }

  /**
   * Updates the user id in keycloak for the controlled basic process
   * or throws if the user is not invited
   * Endpoint: PUT /people-web/persons/secure/me/user
   */
  async updateUserIdInKeycloakForControlledBasicProcess(environmentId: string): Promise<Response> {
    return this.put(
      `${this.basePath}/persons/secure/me/user`,
      environmentId,
      {
        "Content-Type": "application/json",
        // This should always be evbasic
        Realm: "evbasic",
      },
      true
    );
  }

  async uploadAvatar(personId: number, avatarBase64: string): Promise<Response> {
    return this.customCall(
      `${this.basePath}/public/persons/avatar?id=${personId}`,
      {
        method: "POST",
        body: avatarBase64, // Send raw base64 data directly
      },
      {
        "Content-Type": "text/plain",
      },
      true
    );
  }
  putEventVisitReport = async ({
    processId,
    user,
    candidateId,
    eventName,
  }: PutEventVisitReportPayload) => {
    const payload = {
      processPersonId: candidateId,
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.mail,
      processId,
      eventName,
    };
    const response = await this.post(
      `${this.basePath}/persons/feedback/report/activity`,
      payload,
      {},
      true
    );
    return response;
  };
}

// Export singleton instance
export const peopleRepositoryV2 = new PeopleRepositoryV2();
